import { render, staticRenderFns } from "./receiptList.vue?vue&type=template&id=2e21b7f5&scoped=true&lang=html&"
import script from "./receiptList.vue?vue&type=script&lang=js&"
export * from "./receiptList.vue?vue&type=script&lang=js&"
import style0 from "./receiptList.vue?vue&type=style&index=0&id=2e21b7f5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e21b7f5",
  null
  
)

export default component.exports